import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TextFieldHelperComponent {

    constructor() {
    }

    onBlur(args) {

    }

    onReturnPress(args): string {
        return '';
    }

    getTextField(args): any {
        return '';
    }
}
